'use client';

import { useEffect, useState } from 'react';
import {
  CatButton,
  CatIconAdd,
  CatIconArrowForward
} from 'components/blocks-components';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import styles from '../anchor-menu-diagram.module.scss';
import { Conditional } from '@cat-ecom/pcc-components';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';

const EquipmentActions = ({
  btnText,
  hasEquipmentToSelect,
  shouldShowPartsDiagramV2 = false,
  selectedEquipmentInfo,
  openSelectEquipmentDrawer = false
}) => {
  const [isOpenFromNavItem, setIsOpenFromNavItem] = useState(false);

  const { addEquipmentDrawer, selectEquipmentDrawer, editEquipmentDrawer } =
    useMyEquipmentDrawer();

  const equipmentSelectDrawerToDisplay =
    isEmpty(selectedEquipmentInfo) || openSelectEquipmentDrawer
      ? selectEquipmentDrawer
      : editEquipmentDrawer;

  const drawerToDisplay = hasEquipmentToSelect
    ? equipmentSelectDrawerToDisplay
    : addEquipmentDrawer;

  const handleOpen = () => {
    drawerToDisplay?.openDrawer();
    setIsOpenFromNavItem(true);
  };

  // listen for drawer to close
  useEffect(() => {
    if (!drawerToDisplay?.isDrawerOpen && isOpenFromNavItem) {
      setIsOpenFromNavItem(false);
    }
  }, [drawerToDisplay?.isDrawerOpen, isOpenFromNavItem]);

  return (
    <Conditional
      test={shouldShowPartsDiagramV2}
      fallback={
        <Conditional test={btnText} fallback={null}>
          <CatButton
            variant="ghost"
            className={styles['equipment-action__btn']}
            onClick={handleOpen}
          >
            {btnText}
            <CatIconAdd slot="before" />
          </CatButton>
        </Conditional>
      }
    >
      <CatButton data-testid="cat-button" onClick={handleOpen}>
        {btnText}
        <CatIconArrowForward slot="after" />
      </CatButton>
    </Conditional>
  );
};

export default EquipmentActions;
